import ApiInfo from './ApiInfo.js';

class CommonApiInfo extends ApiInfo {
  // 声明接口类
  constructor({
    path,
    type = 'get',
    timeout = 30000,
    headers,
    project = 'sales-crm',
    author = '未定义',
  }) {
    super({
      path,
      type,
      timeout,
      headers,
      project,
      author,
    });
  }
}

export default {
  // 日志列表
  getLogList: new CommonApiInfo({
    path: '/operation-log/list',
    type: 'get',
    author: '郭留永',
  }),
  // 日志详情
  getLogDetailList: new CommonApiInfo({
    path: '/operation-log/detail',
    type: 'get',
    author: '郭留永',
  }),
};
